import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';

/**
 * Secondary tabs container presentation component
 *
 * @param {{}} props
 * @constructor
 */
const Tabs = props => (
    <div className="sales__tabNavWrp">
        <ul className="sales__tabNav">
            {props.options.map((option, key) => (
                <Tab
                    key={key}
                    link={option.link}
                    active={option.name === props.activeTab}
                    disabled={option.disabled}
                >
                    {option.name}
                </Tab>
            ))}
        </ul>
    </div>
);

Tabs.propTypes = {
    /**
     * Available tabs
     */
    options: PropTypes.array,
    /**
     * Active tab name
     */
    activeTab: PropTypes.string
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/js/components/tabs/index.js